// Queue types based on backend DTOs
export const JobStatus = {
  WAITING: 'waiting',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DELAYED: 'delayed',
  PAUSED: 'paused'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];

export interface JobProgress {
  percent: number;
  message?: string;
}

export interface JobFailure {
  message: string;
  stack?: string;
  failedReason: string;
}

export interface JobOptions {
  attempts?: number;
  backoff?: {
    type: string;
    delay: number;
  };
  priority?: number;
  delay?: number;
  removeOnComplete?: boolean | number;
  removeOnFail?: boolean | number;
}

export interface QueueJob {
  id: string | number;
  name: string;
  data: Record<string, any>;
  opts: JobOptions;
  status: JobStatus;
  progress: number;
  progressDetails?: JobProgress;
  attemptsMade: number;
  timestamp: string;
  processedOn?: string;
  finishedOn?: string;
  failedReason?: JobFailure;
  returnvalue?: any;
  ttl?: number;
  delay?: number;
  // Test job metadata
  isTestJob?: boolean;
  testType?: string;
  displayLabel?: string;
}

export interface QueueJobsResponse {
  data: QueueJob[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
  filters: {
    status?: JobStatus;
    jobType?: string;
    search?: string;
    failedOnly?: boolean;
  };
  timestamp: string;
}

export interface QueueFilters {
  status?: JobStatus;
  jobType?: string;
  search?: string;
  failedOnly?: boolean;
  isTestOnly?: boolean;
  isProductionOnly?: boolean;
}

// Common queue statistics (if needed)
export interface QueueStats {
  waiting: number;
  active: number;
  completed: number;
  failed: number;
  delayed: number;
  paused: number;
  total: number;
}

// Scadenza reminder monitoring
export interface ScadenzaReminder {
  _id: string;
  cliente: string;
  descrizione: string;
  dataScadenza: string;
  giorniPreavviso: number;
  inviataNotifica: boolean;
  isActive: boolean;
  fatturaNumero: string;
  responsabileEmail: string;
  createdAt?: string; // Optional because it might be missing in old data or tests
  
  // Job status
  hasScheduledJob: boolean;
  hasActiveJob: boolean;
  hasCompletedJob: boolean;
  hasFailedJob: boolean;
  
  // Job details
  jobs: {
    id: string | number;
    status: JobStatus;
    name: string;
    timestamp: string;
    processedOn?: string;
    finishedOn?: string;
    failedReason?: string;
    isTestJob?: boolean;
  }[];
  
  // Summary info
  lastJobStatus?: JobStatus;
  lastJobTime?: string;
  reminderDue?: boolean;
  reminderOverdue?: boolean;
}
